module.exports = new __parcel__URL__("crystal-rainbow-dark.060631f6.svg").toString();